module.exports = __webpack_public_path__ + "static/media/nightmare_armor.cbad8eb1.png";